import { InputAdornment, TextField } from '@mui/material';
import { Error, Lock } from '@mui/icons-material';
import { Controller, useFormContext, useFormState, FieldValues } from 'react-hook-form';
import { DatePicker } from '@mui/x-date-pickers';
import { getNestedFormErrors } from 'src/shared/functions/getNestedFormErrors';
import dayjs from 'dayjs';
import { Colors } from '../styles/colors';

type ControlledDatePickerProps = {
  inputFormat?: string;
  disabled?: boolean;
  helperText?: string;
  label: string;
  name: string;
  required?: boolean;
  showTodayButton?: boolean;
  disableFuture?: boolean;
};
const ControlledDatePicker = (props: ControlledDatePickerProps) => {
  const { control } = useFormContext<FieldValues>();
  const { errors } = useFormState<FieldValues>();

  const {
    inputFormat = 'YYYY-MM-DD',
    disabled = false,
    helperText = undefined,
    label,
    name,
    required = false,
    showTodayButton = false,
    disableFuture = undefined,
  } = props;
  // const [selectedDate, setSelectedDate] = useState<Dayjs | null>(value ? dayjs(value) : null);

  // Not used
  // const handleChange = (newValue: Dayjs | null) => {
  //   setValue(name, newValue);
  //   setSelectedDate(newValue);
  // };

  let isError = false;
  const errorMessage = getNestedFormErrors(errors, name);
  if (errorMessage) {
    isError = true;
  }

  const componentId = `datepicker-${name}-${Date.now().toString(36) + Math.random().toString(36).substring(2)}`;

  const displayHelperText = (isError && errorMessage) || helperText ? <em>{errorMessage || helperText}</em> : null;

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => {
        return (
          <DatePicker
            format={inputFormat}
            label={label}
            readOnly={disabled}
            displayWeekNumber
            onChange={(date) => field.onChange(date)}
            value={field.value ? dayjs(field.value) : null}
            disabled={disabled}
            sx={{
              '& .MuiInputBase-root': {
                backgroundColor: disabled ? Colors.Form.DisabledInput : '#fff',
              },
            }}
            slotProps={{
              textField: {
                size: 'small',
                fullWidth: true,
                helperText: displayHelperText,
                error: isError,
                id: componentId,
                disabled,
                required,
                variant: 'outlined',
                InputLabelProps: { shrink: true },
                InputProps:
                  isError || disabled
                    ? {
                        'aria-required': required,
                        'aria-invalid': isError,
                        endAdornment: (
                          <InputAdornment position='end'>
                            {isError && <Error sx={{ color: 'error.main' }} />}
                            {disabled && <Lock sx={{ color: 'text.disabled' }} />}
                          </InputAdornment>
                        ),
                      }
                    : {},
              },
            }}
            disableFuture={disableFuture}
            slots={{
              textField: TextField,
            }}
          />
        );
      }}
    />
  );
};

export default ControlledDatePicker;
